// Environment-specific endpoints — from src/runtimeConfig.js (this
// deployment's env-config.js; .env.local only under `npm start`). No
// built-in defaults: dev and prod each get their own values at deploy.
import runtimeConfig from './runtimeConfig';

export const API_URL = runtimeConfig.apiUrl;

// Captures are served through this environment's CloudFront distribution.
export const CAPTURES_CDN_URL = runtimeConfig.capturesCdnUrl;

// Splat/point-cloud uploads are fetched directly from S3, bypassing CloudFront.
export const S3_UPLOADS_BASE_URL = runtimeConfig.uploadsBaseUrl;

// Public parts of uploads (thumbnails, hover previews) through the same
// CloudFront distribution — the bucket is closed to direct public reads.
export const UPLOADS_PUBLIC_URL = CAPTURES_CDN_URL ? `${CAPTURES_CDN_URL}/app/uploads` : S3_UPLOADS_BASE_URL;
